export default __webpack_public_path__ + "static/media/green-check.5f3d66b8.svg";